import mapboxgl from 'mapbox-gl';
import { Logic } from './logic';
import { VehicleLogic } from './vehicles';

export class MapLogic {
    private _mapBox?: mapboxgl.Map;
    private _vehicle?: VehicleLogic;

    constructor(private _logic: Logic) {}

    init(element: HTMLElement) {
        if (this._mapBox) return;

        this._mapBox = new mapboxgl.Map({
            container: element,
            style: `https://maps.api.sygic.com/vstyle/gpegl3ewuwcqpp9wkgdyybd1q`,
            center: [11.067112, 49.453643],
            zoom: 4,
            minZoom: 4,
            fadeDuration: 0
        });

        this._mapBox.dragRotate.disable();
        this._mapBox.touchZoomRotate.disableRotation();

        this._mapBox.addControl(
            new mapboxgl.NavigationControl({
                showCompass: false
            }),
            'bottom-right'
        );
    }

    vehicle(): VehicleLogic {
        if (!this._vehicle) {
            this._vehicle = new VehicleLogic(this._logic, this._mapBox);
        }
        return this._vehicle;
    }
}
